import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {ProductLineRecipeCardReportData} from "./product-line-recipe-card-report.data";

@Injectable()
export class ProductLineRecipeCardReportModel extends ReportModel<ProductLineRecipeCardReportData> {
    constructor(injector: Injector) {
        super(injector, ProductLineRecipeCardReportData);
    }
}
